// "Copy link" in the article sidebar. The button keeps its URL in the data
// attribute, so it works even if the page was rendered from cache.
export function initShare(): void {
  document.querySelectorAll<HTMLButtonElement>('[data-copy-link]').forEach((button) => {
    button.addEventListener('click', async () => {
      const url = button.dataset.copyLink || window.location.href;

      try {
        await navigator.clipboard.writeText(url);
      } catch {
        // Clipboard access can be denied — fall back to the share sheet.
        if (navigator.share) {
          void navigator.share({ url });
        }
        return;
      }

      button.classList.add('is-copied');
      window.setTimeout(() => button.classList.remove('is-copied'), 1600);
    });
  });
}
